import React, { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';

const AppLinkRedirect: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Detect device type
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isAndroid) {
      // Extract the path after /applink/
      const path = location.pathname.replace('/applink/', '');
      const search = location.search;
      
      // Construct the deep link URL for Android
      const deepLink = `nemlingo://${path}${search}`;
      
      // Redirect to the deep link
      window.location.href = deepLink;
    } else if (isIOS) {
      // For iOS, redirect to the universal link (same URL format)
      // iOS will handle opening the app if installed
      // This is already the current URL, so no redirect needed
      // The universal link will be handled by iOS automatically
    }
  }, [location]);

  // If not Android or iOS, redirect to download page
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  
  if (!isAndroid && !isIOS) {
    return <Navigate to="/download" replace />;
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <h2>Opening Nemlingo App...</h2>
      <p>If the app doesn't open automatically, please make sure you have Nemlingo installed.</p>
      <a href="/download" style={{ color: '#4A90E2', textDecoration: 'underline' }}>
        Download the app
      </a>
    </div>
  );
};

export default AppLinkRedirect;
